"use client";
import type { ComponentProps } from "react";

import { type SidebarTrigger, useSidebar } from "@/components/ui/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { SidebarLeftIcon } from "./icons";
import { Button } from "./ui/button";

export function SidebarToggle({
  className,
}: ComponentProps<typeof SidebarTrigger>) {
  const { toggleSidebar } = useSidebar();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          data-testid="sidebar-toggle-button"
          onClick={toggleSidebar}
          variant="outline"
          // className="md:px-2 md:h-fit absolute bg-transparent z-[12] !text-black hover:!bg-accent dark:hover:bg-[#3a3a3a] dark:!bg-transparent dark:!text-white dark:hover:!bg-accent border-none top-[8px] right-[10px] text-[#afafaf] group-data-[collapsible=offcanvas]:opacity-0 group-data-[collapsible=offcanvas]:hover:opacity-100 group-data-[collapsible=icon]:opacity-0 group-data-[collapsible=icon]:hover:opacity-100"
          className={`md:px-2 md:h-fit bg-transparent z-[12] !text-black hover:!bg-accent 
                     dark:hover:bg-[#3a3a3a] dark:!bg-transparent dark:!text-white 
                     dark:hover:!bg-accent border-none ${className ?? ""}`}
        >
          <SidebarLeftIcon size={16} />
        </Button>
      </TooltipTrigger>
      <TooltipContent align="end">Toggle Sidebar</TooltipContent>
    </Tooltip>
  );
}
